// extracted by mini-css-extract-plugin
export var glsrStarRating = "insurerSlider-module--glsr-star-rating--eecfb";
export var glsrSummaryRating = "insurerSlider-module--glsr-summary-rating--071cf";
export var glsrSummaryText = "insurerSlider-module--glsr-summary-text--b66c5";
export var insurerRating = "insurerSlider-module--insurerRating--e3450";
export var recommended = "insurerSlider-module--recommended--fdcf7";
export var recommendedBest = "insurerSlider-module--recommendedBest--d89c9";
export var reviewCount = "insurerSlider-module--reviewCount--a8304";
export var reviewSummaryCompact = "insurerSlider-module--review-summary--compact--f6878";
export var slideInner = "insurerSlider-module--slideInner--c2924";
export var slideInnerLogo = "insurerSlider-module--slideInnerLogo--251d3";
export var slideInnerLogoWrap = "insurerSlider-module--slideInnerLogoWrap--1563a";
export var slideInsurer = "insurerSlider-module--slideInsurer--3548f";
export var sliderWrapInsurers = "insurerSlider-module--sliderWrapInsurers--5ac4c";